<template>
    <div class="news-list-item" >
        <div class="news-list-item-card">
            <div class="news-list-item-card-title" tapmode >
                <div class="text-overflow-one">{{data.title}}</div>
                <span @click="openlist()">更多<img src="../assets/lianghui-next.png"></span>
            </div>
            <div class="news-list-item-card-header" v-if="data.labels_arr.length>1">
                <div :class="{active:current==item.id}" tapmode @click.stop="changenav(item.id)" v-for="item in data.labels_arr">{{item.name}}</div>
            </div>
            <div class="news-list-item-card-list font-nomal">
                <div class="news-list-item-card-item" v-for="(item,index) in data.news_lists" tapmode @click.stop="openContent(item)" v-if="index<3">
                    <img v-if="item.thumb"   v-lazy="item.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_120,w_120'" >
                    <div>
                        {{item.title}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from "../utils";

    export default {
        name: "zhuanTi",
        props: {
            data: Object,
            title: String,
        },
        methods: {
            setdefaultImg(event) {
                var el = event.currentTarget;
                el.style.opacity = 0
            },
            openContent(data) {
                if (data.art_link) {
                    utils.openPage(data,this)
                } else {
                    this.$router.push({name: "NewsContent", params: {id: data.art_id}})
                }

            },
            openlist(){
                this.$router.push({name: "ZhuanTiList", params: {id: this.data.art_id}})
            }
        },
    }
</script>

<style scoped>

</style>
